import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface BugReportError {
  message: string;
  stack?: string;
  timestamp: number;
  type: 'console' | 'network';
  details?: any;
}

@Injectable({
  providedIn: 'root'
})
export class BugReportService {
  private http = inject(HttpClient);
  private snackBar = inject(MatSnackBar);

  private errors: BugReportError[] = [];

  constructor() { }

  addError(error: BugReportError) {
    this.errors.push(error);
    console.log('Error captured by BugReportService:', error);
  }

  getErrors() {
    return this.errors;
  }

  hasErrors() {
    return this.errors.length > 0;
  }

  clearErrors() {
    this.errors = [];
  }

  async sendReport() {
    if (this.errors.length === 0) return;

    const errorData = JSON.stringify(this.errors, null, 2);

    // Copy to clipboard
    try {
      await navigator.clipboard.writeText(errorData);
      this.snackBar.open('Errors copied to clipboard', 'Close', { duration: 3000 });
    } catch (err) {
      console.error('Failed to copy errors to clipboard', err);
      this.snackBar.open('Failed to copy errors to clipboard', 'Close', { duration: 3000 });
    }

    // Send to server
    this.http.post('/api/bug_report.php', { errors: this.errors }, { withCredentials: true }).subscribe({
      next: () => {
        this.snackBar.open('Bug report sent to server', 'Close', { duration: 3000 });
        this.clearErrors();
      },
      error: (err) => {
        console.error('Failed to send bug report', err);
        this.snackBar.open('Failed to send bug report', 'Close', { duration: 3000 });
      }
    });
  }
}
